<template>
  <v-container>
    <v-row>
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/banner-finantare.png')"
          class="mx-auto"
          contain
          max-height="100px">
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-center">
          CONȚINUTUL MATERIALELOR PUBLICATE PE ACEST SITE NU REPREZINTĂ ÎN MOD OBLIGATORIU POZIȚIA OFICIALĂ A UNIUNII EUROPENE SAU A GUVERNULUI ROMÂNIEI.
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" offset-sm="3">
        <v-card>
          <v-card-title>
            <span>Autentificare platformă</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="validForm" ref="form">
              <v-text-field
                v-model="email"
                label="e-mail"
                required
                :rules="required">
              </v-text-field>
              <v-text-field
                :type="showPass ? 'text' : 'password'"
                v-model="password"
                label="parola"
                required
                :rules="required"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass">
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="login">Autentificați-vă</v-btn>
          </v-card-actions>
          <p class="caption px-4 text-h6">
            <!-- Nu aveți cont?
            <router-link :to="{ name: 'Signup' }">
              Creați unul acum.
            </router-link> -->
          </p>
          <v-alert v-if="$route.params.approved === false || notApproved" type="error">
            Contul dumneavoastră nu a fost încă aprobat de un administrator. Vă rugăm să reîncercați mai târziu.
          </v-alert>
          <v-alert v-if="message" :type="message.type">
            {{ message.text }}
          </v-alert>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/parteneri.png')"
          class="mx-auto"
          contain
          max-height="60px">
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LoginComponent',

  data: () => ({
    validForm: true,
    showPass: false,
    email: null,
    password: null,
    required: [val => !!val || 'Campul nu poate fi gol!'],
    notApproved: false,
    message: null
  }),

  methods: {
    async login () {
      this.message = null
      this.notApproved = false
      const valid = this.$refs.form.validate()
      if (valid) {
        const response = await this.$store.dispatch('login', { email: this.email.trim(), password: this.password.trim() })
        if (response.type === 'success') {
          if (!response.payload.user.approved) {
            this.notApproved = true
          } else {
            // Account -> aplicant
            // AccountEvaluator -> evaluator
            // AccountAdmin -> admin
            if (response.payload.user.role === 'admin') this.$router.push({ name: 'AccountAdmin' })
            else if (response.payload.user.role === 'evaluator') this.$router.push({ name: 'AccountEvaluator' })
            else if (response.payload.user.role === 'aplicant') this.$router.push({ name: 'Account' })
          }
        } else {
          if (response.payload.message === 'Invalid login') {
            this.message = {
              type: 'error',
              text: 'Date de autentificare incorecte.'
            }
          } else {
            this.message = {
              type: 'error',
              text: 'Ne cerem scuze, a aparut o eroare la autentificarea contului d-voastra...'
            }
          }
        }
      }
    }
  }
}
</script>
